/* ============================================================
 * AYU AGB Page – Allgemeine Geschäftsbedingungen
 * Adapted from MENTO AGB for AYU Healthtech LIMITED
 * ============================================================ */
import { IMAGES } from "@/lib/constants";
import { useEffect } from "react";

export default function Agb() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen" style={{ background: "oklch(0.97 0.005 80)" }}>
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[oklch(0.97_0.005_80/0.95)] backdrop-blur-md shadow-sm py-3">
        <div className="container flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src={IMAGES.logo} alt="AYU" className="h-10 w-auto" />
          </a>
          <a href="/" className="text-sm text-[oklch(0.52_0.09_128)] font-medium hover:underline" style={{ fontFamily: "var(--font-body)" }}>
            ← Zurück zur Startseite
          </a>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-28 pb-20">
        <div className="container max-w-3xl">
          <h1 className="text-3xl sm:text-4xl font-bold text-[oklch(0.2_0.02_80)] mb-2">
            Allgemeine Geschäftsbedingungen
          </h1>
          <p className="text-sm text-[oklch(0.45_0.03_80)] mb-8" style={{ fontFamily: "var(--font-body)" }}>
            Stand: März 2026
          </p>

          <div className="space-y-8 text-[oklch(0.35_0.02_80)] leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
            <p>
              AYU Healthtech LIMITED<br />
              128 City Road, London, EC1V 2NX, United Kingdom<br />
              E-Mail: office@ayu-rveda.com
            </p>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">1. Geltungsbereich</h2>
              <p className="mb-2">1.1 Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die über unsere Website, Plattformen oder andere Vertriebskanäle zwischen AYU Healthtech LIMITED (nachfolgend „wir" oder „AYU") und unseren Kunden geschlossen werden.</p>
              <p className="mb-2">1.2 Unsere Dienste stehen Kunden weltweit zur Verfügung, mit besonderem Fokus auf die EU und andere internationale Märkte.</p>
              <p>1.3 Abweichende oder ergänzende Bedingungen des Käufers werden nicht Vertragsbestandteil, es sei denn, wir haben ihnen ausdrücklich schriftlich zugestimmt.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">2. Vertragsschluss und Kaufort</h2>
              <p className="mb-2">2.1 Der Kaufvertrag für unsere Produkte oder Dienstleistungen wird ausschließlich im Vereinigten Königreich geschlossen.</p>
              <p className="mb-2">2.2 Mit Abschluss des Kaufvertrags erklärt sich der Kunde ausdrücklich damit einverstanden, dass der Kauf als im Vereinigten Königreich stattfindend gilt, unabhängig von seinem Standort.</p>
              <p>2.3 Die Kommunikation bezüglich des Kaufs, einschließlich der Zahlungsabwicklung, erfolgt elektronisch.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">3. Steuerregelungen (MwSt.)</h2>
              <p className="mb-2">3.1 Verkäufe an Kunden außerhalb des Vereinigten Königreichs, insbesondere innerhalb der Europäischen Union (EU), werden gemäß den britischen Steuervorschriften als 0% MwSt. (steuerfreie) Exporte behandelt.</p>
              <p className="mb-2">3.2 Es liegt in der Verantwortung des Käufers, etwaige lokale Steuern oder Abgaben in seinem Heimatland zu entrichten. AYU übernimmt keine Verantwortung für solche Verpflichtungen.</p>
              <p>3.3 Kunden innerhalb des Vereinigten Königreichs wird die geltende britische MwSt. (derzeit 20%) berechnet.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">4. Transparenzpflichten</h2>
              <p className="mb-2">4.1 Vor Abschluss des Kaufvertrags wird jeder Käufer darüber informiert, dass:</p>
              <ul className="list-disc list-inside mb-2 space-y-1 ml-4">
                <li>Der Kaufvertrag im Vereinigten Königreich geschlossen wird.</li>
                <li>Verkäufe in Länder außerhalb des UK, insbesondere in die EU, mit 0% MwSt. besteuert werden.</li>
                <li>Etwaige zusätzliche Steuerpflichten im Heimatland des Käufers nicht von AYU übernommen werden.</li>
              </ul>
              <p>4.2 Diese Informationen werden auf unserer Website und in der Bestellbestätigung deutlich angezeigt.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">5. Zahlungsabwicklung</h2>
              <p className="mb-2">5.1 AYU stellt sicher, dass der Kaufprozess durch technische Mittel als im Vereinigten Königreich abgeschlossen dokumentiert wird.</p>
              <p className="mb-2">5.2 Zahlungen werden ausschließlich in Euro abgewickelt, sofern nicht ausdrücklich eine andere Währung vereinbart wurde.</p>
              <p>5.3 Käufer sind verpflichtet, korrekte Rechnungs- und Zahlungsinformationen anzugeben.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">6. Haftung</h2>
              <p className="mb-2">6.1 AYU haftet nicht für steuerliche Verpflichtungen, die Kunden in ihrem Heimatland aufgrund von Käufen entstehen.</p>
              <p>6.2 Der Käufer ist dafür verantwortlich, sich über die Steuervorschriften in seinem Heimatland zu informieren.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">7. Anwendbares Recht und Gerichtsstand</h2>
              <p className="mb-2">7.1 Alle Rechtsbeziehungen zwischen AYU und dem Käufer unterliegen ausschließlich dem Recht des Vereinigten Königreichs.</p>
              <p>7.2 Gerichtsstand für Streitigkeiten aus oder im Zusammenhang mit diesem Vertrag ist London, Vereinigtes Königreich.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">8. Änderungen der AGB</h2>
              <p className="mb-2">8.1 AYU behält sich das Recht vor, diese AGB jederzeit zu ändern. Änderungen gelten nicht für bereits geschlossene Verträge.</p>
              <p>8.2 Die aktuelle Version der AGB ist auf dieser Website verfügbar.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">9. Gesundheitsdienst – Haftungsausschluss</h2>
              <p className="mb-2">Der von AYU angebotene Gesundheitsdienst dient ausschließlich der persönlichen Gesundheitsberatung auf Basis ayurvedischer Prinzipien und dem allgemeinen Wohlbefinden. Er ist darauf ausgelegt, Einblicke in persönliche Gesundheitsmuster, Phänotypen und individuelle Empfehlungen zu ermöglichen.</p>
              <p className="mb-2">AYU ist kein Therapie-Tool und kein Diagnose-System. Der Dienst ist nicht dazu bestimmt, Krankheiten zu diagnostizieren, zu behandeln, zu heilen oder zu verhindern. Kunden wird empfohlen, bei gesundheitlichen Bedenken einen Arzt oder qualifizierten Gesundheitsdienstleister zu konsultieren.</p>
              <p className="mb-2">Gesundheitsdaten gelten als sensible personenbezogene Daten. AYU verarbeitet diese Daten ausschließlich in Übereinstimmung mit dem UK Data Protection Act 2018 und der DSGVO. Alle Daten werden verschlüsselt und anonymisiert verarbeitet.</p>
              <p className="mb-2">Die Empfehlungen und Erkenntnisse aus AYU dienen ausschließlich der persönlichen Information und sollten nicht als alleinige Grundlage für Entscheidungen bezüglich Gesundheit oder Wohlbefinden herangezogen werden.</p>
              <p>Die Empfehlungen basieren auf wissenschaftlich fundierten Methoden und ayurvedischen Prinzipien, sind aber durch individuelle Variabilität begrenzt. AYU garantiert nicht, dass die Ergebnisse vollständig, fehlerfrei oder für einen bestimmten Zweck geeignet sind.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">10. DNA-Test – Besondere Bestimmungen</h2>
              <p className="mb-2">Der optionale Darm-Mikrobiom DNA-Test dient ausschließlich Lifestyle- und Wellness-Zwecken. Er analysiert bis zu 1.900 Mikrobiom-Positionen und bemisst 47 Vitalstoffe.</p>
              <p className="mb-2">Der DNA-Test ist nicht dazu bestimmt, Krankheiten zu diagnostizieren, zu behandeln, zu heilen oder zu verhindern. Die Ergebnisse dienen der persönlichen Information.</p>
              <p className="mb-2">Genetische Daten werden als besonders sensible Daten behandelt. Kunden werden bei der Übermittlung an Labore anonymisiert. Mit dem Kauf stimmen Kunden ausdrücklich der Erhebung, Analyse und Speicherung ihrer genetischen Daten zu.</p>
              <p>Der DNA-Test wird in Zusammenarbeit mit GENOpuzzle.com durchgeführt. Die Laboranalyse unterliegt den Qualitätsstandards und Datenschutzrichtlinien von GENOpuzzle.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">11. KI-Nutzung</h2>
              <p className="mb-2">11.1 Der AYU Gesundheitsdienst basiert auf der Integration von künstlicher Intelligenz (KI). Die Nutzung dieser Funktionalität ist derzeit Teil des AYU-Dienstes.</p>
              <p className="mb-2">11.2 Wir weisen ausdrücklich darauf hin, dass wir keinen Einfluss auf die Nutzungsbedingungen und Preisgestaltung des KI-Anbieters haben. Sollte der KI-Anbieter in Zukunft Gebühren einführen, kann dies Auswirkungen auf die Preisgestaltung von AYU haben.</p>
              <p>11.3 AYU ist nicht verantwortlich für die Verfügbarkeit, Funktionalität oder zukünftige Kosten der zugrunde liegenden KI-Technologie.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">12. Widerrufsrecht</h2>
              <p className="mb-2">Gemäß den Consumer Contracts Regulations 2013 gilt das Widerrufsrecht nicht für:</p>
              <ul className="list-disc list-inside mb-2 space-y-1 ml-4">
                <li>Personalisierte Dienstleistungen: Die Dienste von AYU, wie Gesundheitsberatung auf Basis ayurvedischer Prinzipien und Mikrobiom-Analysen, sind auf den Kunden zugeschnitten und können nicht wiederverwendet werden.</li>
                <li>Sofortige Bereitstellung digitaler Inhalte: Der Zugang zu digitalen Inhalten beginnt sofort, und mit der Zustimmung verzichten Kunden auf ihr Widerrufsrecht.</li>
              </ul>
              <p className="mb-2">Mit Abschluss des Kaufprozesses stimmt der Kunde ausdrücklich zu:</p>
              <ul className="list-disc list-inside mb-2 space-y-1 ml-4">
                <li>Der sofortigen Bereitstellung von Diensten und digitalen Inhalten.</li>
                <li>Dem Verzicht auf sein Widerrufsrecht.</li>
              </ul>
              <p>Sobald Dienste oder digitale Inhalte bereitgestellt wurden, erfolgt keine Rückerstattung.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">13. Kontakt</h2>
              <p>
                Für Fragen oder zusätzliche Informationen kontaktieren Sie uns bitte:<br /><br />
                AYU Healthtech LIMITED<br />
                128 City Road, London, EC1V 2NX, United Kingdom<br />
                E-Mail: <a href="mailto:office@ayu-rveda.com" className="text-[oklch(0.52_0.09_128)] hover:underline">office@ayu-rveda.com</a>
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
